module.exports = __webpack_public_path__ + "static/kvm_5.da51740e.jpg";